import { useEffect, useState } from "react";

function Hero() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <>
            {!loading && (
                <section className="hero-section">
                    <div className="hero-card">
                        <div className="hero-content">
                            <h1>Discover amazing games</h1>
                            <p>From indie darlings to AAA blockbusters, find your next favorite game</p>
                            <button className="hero-btn">Explore now</button>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default Hero;